import React, { useState, useEffect, useRef } from "react";
import { useTranslate } from "./TranslationText";

const SimpleFileUpload = ({
  isMulti,
  isServer = false,
  onChange,
  accept,
  disabled = false,
  className = "",
  required = false,
  label = "",
  initialFiles = [],
}) => {
  //const [uploadedFiles, setUploadedFiles] = useState([]);
  const { translate } = useTranslate();
  const [serverFiles, setServerFiles] = useState(initialFiles);
  const inputRef = useRef(null);

  useEffect(() => {
    // Load initial files (if provided)
    setServerFiles(initialFiles);
  }, [initialFiles]);

  const getFileNameFromPath = (path) => {
    if (typeof path !== "string" || path.trim() === "") {
      return "";
    }

    try {
      const pathname = new URL(path, window.location.origin).pathname;
      const cleanPath = pathname.split("?")[0].split("#")[0];
      const lastPart = cleanPath.split("/").filter(Boolean).pop();
      return decodeURIComponent(lastPart || "");
    } catch (error) {
      const cleanPath = path.split("?")[0].split("#")[0];
      const lastPart = cleanPath.split("/").filter(Boolean).pop();
      return decodeURIComponent(lastPart || "");
    }
  };

  const getDisplayFileName = (file) => {
    const isLocalFile = file?.file instanceof Blob;
    if (isLocalFile) {
      return file?.name || "";
    }

    const fileUrl =
      typeof file?.file === "string" ? file.file : file?.documentFile;
    const fileNameFromUrl = getFileNameFromPath(fileUrl);

    return fileNameFromUrl || file?.name || "";
  };

  const handleFileChange = (e) => {
    const files = Array.from(e.target.files);
    setServerFiles(files);
    //setUploadedFiles(files);
  };

  const handleUploadClick = () => {
    if (inputRef.current && !disabled) {
      inputRef.current.click();
      //document.getElementById("file-input").click();
    }
  };

  const handleFileClick = (file) => {
    if (typeof file?.file === "string") {
      window.open(file.file, "_blank", "noopener,noreferrer");
      return;
    }

    if (file?.file instanceof Blob) {
      const fileURL = URL.createObjectURL(file.file);
      window.open(fileURL, "_blank", "noopener,noreferrer");
      return;
    }

    if (typeof file?.documentFile === "string") {
      window.open(file.documentFile, "_blank", "noopener,noreferrer");
    }
  };

  return (
    <div>
      {!!label &&
        <label className="capatalize_text">
          {label}  {required && <span style={{color:'red'}} >*</span>}
        </label>
      }
      <div className="input-group">
        {/* Display both server and newly uploaded file names */}
        <input
          type="text"
          className="form-control"
          placeholder={translate("web.noFileSelected", "No file selected")}
          style={{ cursor: "pointer", height: 37.6 }}
          value={
            serverFiles.length > 0
              ? [
                ...serverFiles.map((file) => getDisplayFileName(file)),
                //...uploadedFiles.map((file) => file.name),
              ].join(",")
              : ""
          }
          readOnly
          onClick={() => {
            if (serverFiles.length === 1) {
              handleFileClick(serverFiles[0]);
            } else if (serverFiles.length > 1) {
              serverFiles.forEach((file) => handleFileClick(file));
            }
          }}
        />
        <div
          style={{
            cursor: disabled ? "not-allowed" : 'pointer',
            opacity: disabled && 0.65,

          }}
          className="input-group-text bg-white text-success"
          id="basic-addon2"
          onClick={handleUploadClick}
        >
          {translate("web.uploadFile", "Upload File")}
        </div>
      </div>

      {/* Hidden file input field */}
      <input
        id="file-input"
        type="file"
        multiple={isMulti}
        style={{ display: "none" }}
        onChange={onChange}
        accept={accept}
        ref={inputRef}
        required={required}
      //onChange={handleFileChange}
      />
    </div>
  );
};

export default SimpleFileUpload;
